import { useEffect, useState } from "react";

// type UsePromiseProps<T> = {
//   promise: () => Promise<T>;
// };
function useEffectPromise<T>(callback: () => Promise<T>) {
  const [dataFetched, setDataFetched] = useState<T | null>(null);
  useEffect(() => {
    callback()
      .then((res) => {
        setDataFetched(res);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [callback]);

  return dataFetched;
}

export default useEffectPromise;
